import { setAuthInHeader } from '../api'

const mutations = {
    SET_IS_ADD_BOARD(state, toggle) {
        state.isAddBoard = toggle
    },
    SET_BOARDS(state, boards) {
        console.log('SET_BOARDS');
        state.boards = boards;
    },
    LOGIN(state, { session_id, user_id, user_level }) {
        let time = new Date();
        time.setMinutes(time.getMinutes() + state.SESSION_CLEAR_TIME_MINUTES);        

        if (!session_id) return;

        state.session_id = session_id;
        state.user_id = user_id; // 얘 null이면 isAuth false 인듯.
        state.user_level = user_level;
        state.session_time = time;
        
        localStorage.setItem('session_id', session_id);
        localStorage.setItem('user_id', user_id);
        localStorage.setItem('user_level', user_level);
        localStorage.setItem('session_time', time.toString());
        setAuthInHeader(session_id); // 얜 뭐지?
    },
    LOGIN_CHECK(state) {
        //state.user_id = user_id; // 얘 null이면 isAuth false 인듯.
        let now = new Date();
        let sessionTime = new Date(localStorage.getItem('session_time'));
        if(sessionTime !== null && sessionTime > now) {
            let addMin = state.SESSION_CLEAR_TIME_MINUTES - 
                ((sessionTime.getHours() - now.getHours()) * 60 + sessionTime.getMinutes() - now.getMinutes());

            console.log(`JS test login_check true>> sessionTime:[${sessionTime}], addMin[${addMin}]`);
            
            sessionTime.setMinutes(sessionTime.getMinutes() + addMin);
            localStorage.setItem('session_time', sessionTime.toString());
            return true;
        }
        else {
            console.log(`JS test login_check false >> `);
            state.session_id = null;
            state.user_id = null;
            state.user_level = 0;
            state.session_time = null;
            localStorage.removeItem('session_id');
            localStorage.removeItem('user_id');
            localStorage.removeItem('user_level');
            localStorage.removeItem('session_time');
            return false;
        }
    },
    LOGOUT(state) {
        state.session_id = null;
        state.user_id = null;
        delete localStorage.session_id;
        delete localStorage.user_id;
        delete localStorage.user_level;

        setAuthInHeader(null);
    },
    SET_BOARD(state, board) {
        state.board = board;
    },
    SET_CARD(state, card) {
        state.card = card;
    },
    SET_THEME(state, color) {
        console.log('SET_THEME', color);
        state.bodyColor = color || '#ffffff';
        state.navbarColor = color ? 'rgba(0,0,0,.15)' : '#026aa7';
    },
    SET_IS_SHOW_BOARD_SETTINGS(state, toggle) {
        state.isShowBoardSettings = toggle;
    },

    SET_GAME_API_CONST_INFO(state, _info) {
        // items
        const items = _info.items;
        items.forEach((item) => {
            state.item_info.push({info: item, name: item.item.name});
        });
        // const
        state.const = _info.cosnt;
        // category
        _info.contents_info[0].forEach((info) => {
            state.category_list.push({info, name: info.name });
        });

        // title
        _info.contents_info[1].forEach((info) => {
            state.title_list.push({info, name: info.name });
        });

        state.const_refresh_flag = false;
    },
    SET_POST_TEMPLATE_INFO(state, _info) {
        state.post_template_info = _info;
    },
    SET_GMS_SERVER_TYPE(state, {serverType, serverText}) {
        state.gms_server_type = serverType;
        state.gms_server_name = serverText;
    },
    INIT_EVENT_INFO(state) {
        state.post_template_info = [];
        state.item_info = [];
        state.const = [];
        state.category_list = [];
        state.title_list = [];
        state.const_refresh_flag = true;
    },

    SET_GAME_PACKAGE(state, _package){
        console.log("SET_GAME_PACKAGE");
        state.selected_game_package = _package;
    },
    SET_GAME_SERVER(stage,_server_index)
    {
        console.log("SET_GAME_PACKAGE");
        state.selected_game_server = _server_index;
    },
    SET_DASHBOARD_INFO(state, { cpu_dash_borad_info }) {
        state.cpu_dash_borad_info = cpu_dash_borad_info;
    },
    SET_QUIZCASH_DASHBOARD_INFO(state, { quizcash_dash_borad_info }) {
        state.quizcash_dash_borad_info = quizcash_dash_borad_info;
    },
    SET_CARRYGOLD_DASHBOARD_INFO(state, { carrygold_dash_borad_info }) {
        state.carrygold_dash_borad_info = carrygold_dash_borad_info;
    },
    SET_CPU_USERLIST_RECENT(state , {userlist}){
        state.user_list_cpu_sort_recent = userlist;
    },
    SET_CPU_USERLIST_REFEREE(state ,{userlist}){
        state.user_list_cpu_sort_referee = userlist;  
    },
    SET_CPU_USERLIST_BP_CUR(state ,{userlist}){
        state.user_list_cpu_sort_cur_bp = userlist;
    },
    SET_CPU_USERLIST_BP_DAILY(state ,{userlist}){
        state.user_list_cpu_sort_daily_bp = userlist;
    },
    SET_CPU_USERLIST_COIN(state ,{userlist}){
        state.user_list_cpu_sort_point = userlist;
    },
    SET_CPU_USERLIST_EARN_COIN_TOTAL(state ,{userlist}){
        state.user_list_cpu_sort_point_total = userlist;
    },


    SET_QUIZCASH_USERLIST_RECENT(state , {userlist}){
        state.user_list_quizcash_sort_recent = userlist;
    },
    SET_QUIZCASH_USERLIST_REFEREE(state ,{userlist}){
        state.user_list_quizcash_sort_referee = userlist;  
    },
    SET_QUIZCASH_USERLIST_BP_CUR(state ,{userlist}){
        state.user_list_quizcash_sort_cur_bp = userlist;
    },
    SET_QUIZCASH_USERLIST_BP_DAILY(state ,{userlist}){
        state.user_list_quizcash_sort_daily_bp = userlist;
    },
    SET_QUIZCASH_USERLIST_COIN(state ,{userlist}){
        state.user_list_quizcash_sort_point = userlist;
    },
    SET_QUIZCASH_USERLIST_EARN_COIN_TOTAL(state ,{userlist}){
        state.user_list_quizcash_sort_point_total = userlist;
    },


    SET_CARRYGOLD_USERLIST_RECENT(state , {userlist}){
        state.user_list_carrygold_sort_recent = userlist;
    },
    SET_CARRYGOLD_USERLIST_GEM(state ,{userlist}){
        state.user_list_carrygold_sort_gem = userlist;
    },
    SET_CARRYGOLD_USERLIST_EARN_GEM_TOTAL(state ,{userlist}){
        state.user_list_carrygold_sort_gem_total = userlist;
    },
    SET_CARRYGOLD_USERLIST_COIN(state ,{userlist}){
        state.user_list_carrygold_sort_point = userlist;
    },
    SET_CARRYGOLD_USERLIST_EARN_COIN_TOTAL(state ,{userlist}){
        state.user_list_carrygold_sort_point_total = userlist;
    },
    SET_CARRYGOLD_USERLIST_BP(state ,{userlist}){
        state.user_list_carrygold_sort_bp = userlist;
    },
    SET_CARRYGOLD_USERLIST_REFEREE(state ,{userlist}){
        state.user_list_carrygold_sort_referee = userlist;
    },

    // 하우스 애드
    SET_HOUSEAD_APP_LIST(state, list) {
        state.housead_app_list = list || [];
    },
    SET_HOUSEAD_APP_ITEM(state, { index, item }) {
        if (index >= 0 && index < state.housead_app_list.length) {
            state.housead_app_list.splice(index, 1, item);
        } else {
            state.housead_app_list.push(item);
        }
    },
    REMOVE_HOUSEAD_APP(state, index) {
        state.housead_app_list.splice(index, 1);
    },
    SET_HOUSEAD_REWARD_TYPES(state, list) {
        state.housead_reward_types = list || [];
    },
    SET_HOUSEAD_REWARD_TYPE_ITEM(state, { index, item }) {
        if (index >= 0 && index < state.housead_reward_types.length) {
            state.housead_reward_types.splice(index, 1, item);
        } else {
            state.housead_reward_types.push(item);
        }
    },
    REMOVE_HOUSEAD_REWARD_TYPE(state, index) {
        state.housead_reward_types.splice(index, 1);
    },
    SET_HOUSEAD_APP_REWARD_SETTINGS(state, list) {
        state.housead_app_reward_settings = list || [];
    },
    SET_HOUSEAD_APP_REWARD(state, { appId, rewardTypeId }) {
        const idx = state.housead_app_reward_settings.findIndex(s => s.appId === appId);
        if (!rewardTypeId) {
            if (idx >= 0) state.housead_app_reward_settings.splice(idx, 1);
            return;
        }
        const entry = { appId, rewardTypeId };
        if (idx >= 0) state.housead_app_reward_settings.splice(idx, 1, entry);
        else state.housead_app_reward_settings.push(entry);
    },
    SET_HOUSEAD_AD_CONFIGS(state, list) {
        state.housead_ad_configs = list || [];
    },
    SET_HOUSEAD_AD_CONFIG_ORDER(state, orderedAppIds) {
        state.housead_ad_config_order = orderedAppIds || [];
    },
    REORDER_HOUSEAD_AD_CONFIG(state, { fromIndex, toIndex }) {
        const order = state.housead_ad_config_order.slice();
        const [removed] = order.splice(fromIndex, 1);
        order.splice(toIndex, 0, removed);
        state.housead_ad_config_order = order;
    },
    SET_HOUSEAD_AD_CONFIG(state, { appId, adType, excludedAppIds, rewardTypeId, active }) {
        const idx = state.housead_ad_configs.findIndex(c => c.appId === appId);
        const prev = idx >= 0 ? state.housead_ad_configs[idx] : {};
        const entry = {
            appId,
            adType: adType !== undefined ? adType : (prev.adType || 'install'),
            excludedAppIds: excludedAppIds !== undefined ? (excludedAppIds || []) : (prev.excludedAppIds || []),
            rewardTypeId: rewardTypeId !== undefined ? (rewardTypeId || null) : (prev.rewardTypeId || null),
            active: active !== undefined ? active : (prev.active !== undefined ? prev.active : 'Y'),
        };
        if (idx >= 0) state.housead_ad_configs.splice(idx, 1, entry);
        else state.housead_ad_configs.push(entry);
    },
}

export default mutations;